import 'font-awesome/css/font-awesome.css';
import './css/site.css';
import './webpack-component-loader';
import * as ko from 'knockout';


import ShellComponent, {ShellViewModelParams} from './components/shell/shell';
import {Application} from "./services/application";
import OidcManager from "./services/api/oidcManager";
import {AppConfig} from "./services/app-config";

function getMeta(metaName: string) {
    const metas = document.getElementsByTagName('meta');

    for (let i = 0; i < metas.length; i++) {
        if (metas[i].getAttribute('name') === metaName) {
            return metas[i].getAttribute('content');
        }
    }

    return '';
}

let estimatorSpa = getMeta('estimatorSpa');
let estimatorApi = getMeta('estimatorApi');
let costbooksApi = getMeta('costbooksApi');
let identityServer = getMeta('identityServer');

let config : AppConfig = {
    api: {
        estimator: estimatorApi!,
        costbooks: costbooksApi!,
    }
};

let oidcManager = new OidcManager({
    authority: identityServer!,
    client_id: "tne.estimator.spa",
    redirect_uri: estimatorSpa! + "/callback",
    response_type: "id_token token",
    scope:"openid profile tne.estimator.api tne.costbooks.api",
    post_logout_redirect_uri : estimatorSpa!,
    automaticSilentRenew: false,
    silent_redirect_uri: estimatorSpa! + "/silentRenew",
    accessTokenExpiringNotificationTime: 300
});


oidcManager.authorize().then(() => {
    ko.components.register('shell', ShellComponent);

    ko.applyBindings(<ShellViewModelParams> {
        app: new Application(config, oidcManager)
    });
   
    if (module.hot) {
        module.hot.accept();
        module.hot.dispose(() => ko.cleanNode(document.body));
    }
});




// WEBPACK FOOTER //
// ./ClientApp/boot.ts